import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

// Redusers for admin
import auth from "./store/reducers/auth/auth";
import forClients from "./store/reducers/admin/forClients/forClients";
import forAdmins from "./store/reducers/admin/forAdmins/forAdmins";
import forManageAccount from './store/reducers/admin/forManageAccont/forManageAccont';
import forProjects from './store/reducers/admin/forProjects/forProjects';
import forClientFolders from './store/reducers/admin/forClients/forClientFolders';
import forMilestones from './store/reducers/admin/forMilestone/forMilestone';

//reducers for client
import milestone from './store/reducers/client/milestone';
import myinfo from './store/reducers/client/myinfo';
import forProjectPeriod from './store/reducers/admin/forProjectPeriod/forProjectPeriod';
import userFolders from './store/reducers/client/userFolders';
// redux
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  auth,
  forClients,
  forAdmins,
  forManageAccount,
  forProjects,
  forClientFolders,
  forMilestones,
  forProjectPeriod,
  myinfo,
  milestone,
  userFolders

});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
